module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }